import postal from 'postal';
import queryString from 'query-string';

export function getLocationState() {
  return queryString.parse(window.location.search);
}

function publishLocationStateChanged() {
  postal.publish({
    channel: 'window.events',
    topic: 'location-state-changed',
    data: getLocationState(),
  });
}

const existingOnPopState = window.onpopstate;
window.onpopstate = () => {
  if (existingOnPopState) existingOnPopState();
  publishLocationStateChanged();
};

function buildUrl(state, hash) {
  const stringifiedState = queryString.stringify(state);

  return window.location.origin
    + window.location.pathname
    + (stringifiedState ? `?${stringifiedState}` : '')
    + hash;
}

function pushHistory(url) {
  window.history.pushState(null, document.title, url);
  publishLocationStateChanged();
}

export function setLocationHash(hash) {
  const url = buildUrl(getLocationState(), hash);

  pushHistory(url);
}
